<template>
  <div class="container mt-3">
    <div class="text-center"><h3>Workshop Schedule</h3></div>
    <div class="row justify-content-center mb-5">
      <div class="col-md-6 text-center">
        <img v-lazy="'/resource_social22/img/schedule.PNG'" class="" width="100%"/>
      </div>

    </div>

    <div class="text-center"><h3>Keynote Introduction</h3></div>
    <div>
      <div class="mt-4" v-for="(keynote, i) in keynotes" :key="i">
        <h4><span class="text-primary">Keynote {{ i + 1 }}: </span> {{ keynote.title }} </h4>
        <div class="text-center">
          <img v-lazy="keynote.speaker_img" class="img-raised" width=150/>
          <div class="h5 mb-1 mt-3">
            {{ keynote.speaker }}
          </div>
          <div class="h6 ">
            {{ keynote.speaker_ins }}
          </div>
        </div>
        <div class="">
          <div class="">
            <p><span class="font-weight-normal">{{ keynote.bio }}: </span>{{ keynote.speaker_intro }}</p>
          </div>
          <div>
            <p><span class="font-weight-normal">{{ keynote.overview }}: </span>{{ keynote.abstract }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center mt-5"><h3 class="mb-0">Winning Teams for Shared Tasks</h3></div>
    <div class="col-md-12 ml-auto mr-auto">

      <tabs slot="raw-content" tab-content-classes="tab-content-padding text-center">
        <tab-pane v-for="(task, i) in $store.state.tasks" :key="i">
          <template slot="label">Task {{ i + 1 }}</template>
          <p class="category">{{ task }}</p>
          <div class="row">
            <div class="col-md-4" v-for="(team, j) in winningTeams[i]" :key="j">
              <h5 class="mb-0 mt-2">{{ winningTitle[j] }}</h5>
              <div class="text-primary font-weight-normal h5 mb-0 mt-1"> {{ team.team_name }}</div>
              <div><span class="font-weight-bold">{{ team.team_member }}</span></div>
              <div> {{ team.ins }}</div>

              <div v-if="team.report" class="mt-1 report">
                <v-btn small rounded depressed :href="team.report" target="_blank" style="text-decoration: none;">
                  <i class="now-ui-icons files_paper"></i>
                  Report
                </v-btn>
              </div>


            </div>
          </div>

        </tab-pane>
      </tabs>
    </div>

  </div>
</template>

<script>
import {Button, TabPane, Tabs} from "@/components";

export default {
  name: "indexWorkshop",
  components: {
    // Card,
    Tabs,
    TabPane,
    [Button.name]: Button,
  },
  data() {
    return {
      keynotes: [
        {
          title: 'Hong Kong’s Experience and Lessons in Fighting COVID-19',
          bio: 'Biography',
          overview: 'Keynote Overview',
          speaker: 'Dr. Lin Yang',
          speaker_img: '/resource_social22/img/spekaer_yanglin.png',
          speaker_ins: 'PolyU',
          speaker_intro: 'Dr. Lin Yang is an Associate Professor in School of Nursing, Hong Kong Polytechnic University. Her research interests include infectious disease and environmental epidemiology, infection control, and vaccination. She has published more than 100 research articles in international peer-review journals and total citations are over 8000 in Google Scholar.',
          abstract: 'The 5th wave of the epidemic in Hong Kong, which started in early 2022, has so far infected more than one million people and killed more than 9,000 people. How has Hong Kong dealt with this outbreak, and what are the experiences and lessons learned? Is there anything we can do to deal with a possible 6th wave?'
        },
        {
          title: '从权贵到富贵：中国传世名画产权变动与社会流动性研究',
          bio: '嘉宾简介',
          overview: '报告摘要',
          speaker: '陈硕 教授',
          speaker_img: '/resource_social22/img/speaker_chenshup.jpg',
          speaker_ins: '复旦大学经济学院',
          speaker_intro: '陈硕目前是复旦大学经济系教授，研究兴趣主要集中于发展经济学、政治经济学、经济史及中国经济。陈硕的英文研究成果发表在American Economic Review、American Political Science Review、American Economic Journal、Journal of Economic Growth、Journal of Development Economics、Journal of Corporate Finance、Journal of Economic Behavior & Organization及Journal of International Business Studies及等经济学、政治科学及管理学顶尖期刊上；中文成果也发表在《经济研究》、《金融研究》、《管理世界》、《世界经济》、《经济学季刊》、《统计研究》等多个国内权威期刊上。陈硕目前主持国家自然科学基金青年、面上及重点项目，以及省部级课题及重大课题。',
          abstract: '主讲人将基于3141幅中国传世名画上的10336个收藏印鉴并结合其所属收藏家个人信息，构建出960至1911年中国前现代奢侈品动产产权的变迁轨迹。该轨迹表明在同一个朝代中画作所有者社会阶层有持续降低的趋势，该趋势在明及清代尤为明显。具体来说，画作收藏家平均官阶在朝代初期往往高于朝代中后期。同时，朝代更迭又使得上述趋势重新开始。之后主讲人将基于1368-1911年分省面板数据验证该趋势与社会流动性之间的相关关系：画作在社会流动性高的地区向低社会阶层集中趋势就越明显。本讲座的目的有两个：第一是增加对中国前现代社会精英阶层家庭财产构成的理解；第二是从奢侈品动产流转这一新视角研究我国前现代社会流动。'
        },
        {
          title: '计算热搜——以新冠疫情为例的集体注意力计算传播分析',
          bio: '嘉宾简介',
          overview: '报告摘要',
          speaker: '周葆华',
          speaker_img: '/resource_social22/img/speaker_zhoubaohua.jpg',
          speaker_ins: '复旦大学新闻学院',
          speaker_intro: '周葆华，复旦大学新闻学院教授、博士生导师、副院长，新媒体传播专业硕士项目主任。国家万人计划哲学社会科学领军人才，教育部首批青年“长江学者”（2015），国家社科基金重大项目首席专家。主要研究兴趣为新媒体传播、受众与传播效果、计算与智能传播、舆论研究等。曾获教育部人文社科优秀成果二等奖、上海市哲学社科优秀成果一等奖等十多项奖励。',
          abstract: '人工智能时代，算法成为集体注意力的新生产机制。其中集体化热点的重要代表——如微博热搜，更是成为集体注意力的重要表征。本报告运用计算传播研究方法，以新冠疫情为例，基于2019-2021年的微博热搜数据，分析集体注意力的总体特征，在集合层面上随着时间和疫情发展的协变关系，以及个体层面上影响注意力分布不均的重要因素。'
        },
        {
          title: 'Do I Sound Like the Person I’m Talking to? A Brief Talk on Imitation in Speech',
          bio: 'Biography',
          overview: 'Keynote Overview',
          speaker: 'Dr. Yao Yao',
          speaker_img: '/resource_social22/img/speaker_yaoyao.jpg',
          speaker_ins: 'PolyU',
          speaker_intro: 'Dr. Yao Yao is Associate Professor in the Department of Chinese and Bilingual Studies at the Hong Kong Polytechnic University. Her research training is mostly in phonetics, psycholinguistics, and corpus/experimental methods of linguistic research. She is interested in language change and variation, heritage phonological acquisition, and speech processing in bilinguals. She has worked on multiple Chinese languages (Mandarin, Shanghainese, Cantonese, etc.) and English.',
          abstract: 'Imitation is core to human learning. Unintentional imitation is ubiquitous in speech production. Babies learn the language around them through imitating the speech sounds they hear; adults reportedly shift their accent toward the local variety after moving to a new region; couples and close friends often sound more alike as their relationship deepens. The existing literature has documented a wide range of speech imitation phenomena on short-term and longer-term bases, showing interlocutors approaching each other in various acoustic-phonetic measures in the course of verbal communication. However, imitation—or convergence toward the interlocutor—does not always happen. Multiple factors have been proposed to account for the likelihood of imitation, as well as the degree of imitation. These factors fall into several categories, ranging from the linguistic distance between the speakers, linguistic features of the target of imitation, to interpersonal dynamics of the speakers. In this talk, I will go through a diverse collection of studies on phonetic imitation. I will also discuss the underlying mechanisms of imitation and the relationship between imitation and speaker accommodation. '
        },
        {
          title: 'XC - an Explainable AI Method to make your Chatbot Trustable',
          bio: 'Biography',
          overview: 'Keynote Overview',
          speaker: 'Prof. Kam-Fai Wong',
          speaker_img: '/resource_social22/img/speaker_huangjinhui.png',
          speaker_ins: 'CUHK',
          speaker_intro: 'K.F. Wong obtained his Ph.D. from Edinburgh University, Scotland, in 1987. He was a post doctoral researcher in Heriot-Watt University (Scotland), UniSys (Scotland) and ECRC (Germany). At present, he is Professor in the Department of Systems Engineering and Engineering Management, The Chinese University of Hong Kong (CUHK). In parallel, he serves as the Associate Dean (External Affairs) of Engineering, the Director of the Centre for Innovation and Technology (CINTEC), and Associate Director of the Centre for Entrepreneurship (CfE), CUHK. He serves as the President of Asian Federation of Natural Language Processing (AFNLP, 2015-2016), President of the Governing Board of Chinese Language Computer Society CLCS (2015-2017). KF’s research interest focuses on Chinese computing, social media processing and information retrieval. He has published over 250 technical papers in these areas in different international journals and conferences and books. He is Fellow of ACL (2020), Member of ACM, Senior Member of IEEE as well as fellow of the following professional bodies BCS (UK), IET (UK) and HKIE. He is the founding Editor-In-Chief of ACM Transactions on Asian Language Processing (TALIP), and serves as associate editor of International Journal on Computational Linguistics and Chinese Language Processing. He is the Publication Chair of ACL2021, General Chair of AACL-IJCNLP-2020 (virtual), Organization Chair of EMNLP-2019 (HK), Conference Co-Chair of NDBC2016 (SZ), BigComp2016 (HK), NLPCC2015 (Nancheng) and IJCNLP2011 (Thailand); the Finance Chair SIGMOD2007 (BJ); and the PC Co-chair of lJCNLP2006 (Jeju). Also he is a Programme Committee member of many international conferences.',
          abstract: 'Chatbots are popular AI applications in today’s commercial sector. They make extensive use of Natural Language Processing (NLP) and Dialogue System techniques to understand what a human user wants and guide him/her to the desired outcomes. Existing research in chatbot mainly focuses on performance improvement (e.g. to minimize the number of turns to answer a query) and deep learning approaches are commonly used for this purpose. Due to the opaque “black box” nature of deep learning functions, layman users cannot understand the reason and logic behind the chatbot’s decision of his/her request. In fact, lack of explanability renders chatbots confusing and user-unfriendly. By the same token, developers are not sure about the features and factors which contribute most to the trained model. Recently, eXplainable AI (XAI) technology are introduced to overcome this predicament. However, existing XAI methods are mainly used to explain NLP applications based on deep learning on static data. Yet, in practice, each turn (ie text presented by the chatbot system) is generated dynamically based on the conversation history and system interactions with the users. For this reason, existing XAI methods are ineffective for chatbots which involves dynamic data generated from chatting through multiple turns of man-machine interaction. This lays down the objective of our project: to research and develop a novel XAI method, referred to as XC (Explainable Chatbot), to explain features and temporal factors that determine a chatbot’s response or decision. XC can identify (1) the importance of the key phrases leading to the answer and (2) the change of the phrases between conversation turns, which can be viewed as the derivative of the phrase over turns. The former is the “feature” which enables users to uncover the relationships between aspects, sentences and keywords embedded in a dialogue; and the latter is the “time factor” which reveals the chatting behavior of the users reflected by the change of the feature over turns. Respectively, these two pieces of information make the decision and the decision process of a chatbot transparent and traceable. Furthermore, they identify potential flaws in a chatbot and analyze the behavioural changes of a user, which in turn helps developers adjust the underlying chatbot algorithms.'
        },
      ],
      winningTeams: [
        [
          {
            team_name: 'Run',
            team_member: 'Xiangyu Tian, Yuling Shi',
            ins: 'Fudan University',
            report: '/resource_social22/report/Run-task1-report.pdf'
          },
          {
            team_name: 'UIR',
            team_member: 'Mingrui Liu, Jielin Chen',
            ins: 'University of International Relations',
            report: '/resource_social22/report/UIR-task1-report.pdf'
          },
          {
            team_name: 'Harrynotpotter',
            team_member: 'Peng Xia',
            ins: 'Soochow University',
            report: '/resource_social22/report/harrynotpotter-task1-report.pdf'
          },
        ],
        [
          {team_name: 'random seed', team_member: 'Yixia Li', ins: 'The Hong Kong Polytechnic University', report: ''},
          {
            team_name: 'Run',
            team_member: 'Xiangyu Tian, Yuling Shi',
            ins: 'Fudan University',
            report: '/resource_social22/report/Run-task2-report.pdf'
          },
          {team_name: 'Dan*', team_member: 'Danna Lu, Jinyuan Luo', ins: 'Guangzhou University', report: ''},
        ],
        [
          {
            team_name: 'NLPIR',
            team_member: 'Yanhao Wang, Jiahao Cai, Yutao Chen',
            ins: 'Beijing Institute of Technology',
            report: ''
          },
          {team_name: 'BEB2', team_member: 'Jiahao Wu', ins: 'The Hong Kong Polytechnic University', report: ''},
          {team_name: '008', team_member: 'Zehang Lin, Jun Li, Xinhong Chen', ins: 'The Hong Kong Polytechnic University', report: ''},
        ],
        [
          {
            team_name: 'BJTU-ADaM',
            team_member: 'Lixi Zhu, Xiaowen Huang, Jitao Sang, Lei Cheng',
            ins: 'Beijing Jiaotong University',
            report: '/resource_social22/report/'
          },
          {
            team_name: 'Run',
            team_member: 'Xiangyu Tian, Yuling Shi',
            ins: 'Fudan University',
            report: '/resource_social22/report/Run-task4-report.pdf'
          },
          {team_name: 'Dan*', team_member: 'Danna Lu, Jinyuan Luo', ins: 'Guangzhou University', report: ''},
        ],
        [
          {team_name: '008', team_member: 'Zehang Lin, Jun Li, Xinhong Chen', ins: 'The Hong Kong Polytechnic University', report: ''},
          {
            team_name: 'Run',
            team_member: 'Xiangyu Tian, Yuling Shi',
            ins: 'Fudan University',
            report: '/resource_social22/report/Run-task5-report.pdf'
          },
          {
            team_name: 'NLPIR',
            team_member: 'Yanhao Wang, Jiahao Cai, Yutao Chen',
            ins: 'Beijing Institute of Technology',
            report: ''
          },
        ],
      ],
      winningTitle: ['Champion', 'The 1st runner-up', 'The 2nd runner-up'],
    }
  },
}
</script>

<style scoped>
.v-btn__content {
  text-decoration: none;
}

</style>